// MobileStates — estados de borda compartilhados pelas abas de catálogo e pela
// tela de detalhe (A5). CTA "configure fonte" (no_provider), spinner de
// carregamento e empty state. Centraliza o visual pra as 4 abas + detalhe
// usarem o MESMO tratamento da Home A3 (não crashar quando não há fonte).

import { useTranslation } from '@app-iptv/i18n'

import styles from './MobileStates.module.css'

/** CTA "configure sua fonte" — idêntico ao da Home (no_provider). */
export function MobileNoSource({
  onConfigureSource,
}: {
  onConfigureSource?: (() => void) | undefined
}): JSX.Element {
  const { t } = useTranslation()
  return (
    <div className={styles.wrap} data-state="no-provider">
      <h1 className={styles.title}>{t('mobileHome.noSourceTitle')}</h1>
      <p className={styles.text}>{t('mobileHome.noSourceText')}</p>
      {onConfigureSource && (
        <button type="button" className={styles.cta} onClick={onConfigureSource}>
          {t('mobileHome.noSourceCta')}
        </button>
      )}
    </div>
  )
}

/** Spinner de carregamento (mesmo visual da Home). */
export function MobileLoading(): JSX.Element {
  const { t } = useTranslation()
  return (
    <div className={styles.wrap} data-state="loading">
      <div className={styles.spinner} aria-hidden="true" />
      <p className={styles.text}>{t('mobileHome.loading')}</p>
    </div>
  )
}

/** Empty state genérico (título + texto já traduzidos pelo caller). */
export function MobileEmpty({
  title,
  text,
}: {
  title: string
  text?: string | undefined
}): JSX.Element {
  return (
    <div className={styles.wrap} data-state="empty">
      <h2 className={styles.title}>{title}</h2>
      {text && <p className={styles.text}>{text}</p>}
    </div>
  )
}
